/* eslint-disable no-undef */
/* eslint-disable camelcase */
import { hydrateRoot } from 'react-dom/client';
import { Globals } from '@bwoty-web/ui-kit';
import ResortListView from '../shared/views/resortList/resortListView';

const initialStateResortList = window.__INITIAL_STATE_RESORT_LIST__;

/*
  Allow lazy load of components.
  Sets webpack publicPath for files during runtime, since the publicPath is different for each environment.
  Filepaths cannot be relative since the script is run on other domains.
*/
__webpack_public_path__ = `${initialStateResortList?.baseUrl}/static/`;

delete window.__INITIAL_STATE_RESORT_LIST__;
const resortListRoot = document.getElementById('resort-list-view');

if (resortListRoot) {
  hydrateRoot(
    resortListRoot,
    <Globals legacyMode={initialStateResortList.legacyMode} siteId={initialStateResortList.siteId}>
      <ResortListView
        itemContent={initialStateResortList.resortListData.itemContent}
        resortList={initialStateResortList.resortListData.resortList}
        labels={initialStateResortList.resortListData.labels}
        itemType={initialStateResortList.itemType}
        initialIsMobile={initialStateResortList.initialIsMobile}
      />
    </Globals>,
  );
}
